import React, { useState } from "react";

type Props = {
  message?: string;
  showProjectMenu: boolean;
};

const NoticeMessage: React.FC<Props> = ({ message, showProjectMenu }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!message || !isVisible) return null;

  return (
    <div className={`pointer-events-none fixed inset-x-0 ${showProjectMenu ? "top-[102px]" : "top-[62px]"} z-40 px-4 sm:top-[82px] sm:px-5`}>
      <div className="mx-auto flex max-w-header justify-center sm:justify-end">
        <div
          className="pointer-events-auto flex w-full max-w-[360px] items-center gap-3 rounded-[8px] border border-[#D2DFE6] bg-white px-4 py-3 text-sm text-[#1F2122] shadow-lg"
          role="status"
          aria-live="polite"
        >
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E6F2FC] text-[#006AC9]" aria-hidden="true">
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="m5 12 4 4L19 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <p className="font-medium">{message}</p>
          <button
            type="button"
            className="ml-auto flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#768084] hover:bg-[#F4F6F8] hover:text-[#1F2122]"
            aria-label="通知を閉じる"
            onClick={() => setIsVisible(false)}
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeMessage;
